import dynamic from 'next/dynamic';
import React from 'react';

import {
    ClientSideRenderWrapper,
    VideoPlayerLoader,
} from './client-side-video-player.react-component';

import type {ClientSideVideoPlayerProps} from './client-side-video-player.react-component';

export interface ClientSideVideoPlayerByAssetIdProps
    extends Partial<Omit<ClientSideVideoPlayerProps, 'asset'>> {
    assetId: string;
}

const DynamicClientSideVideoPlayerByAssetId = dynamic(
    () => import('./video-player-client.react-component').then((m) => m.VideoPlayerByAssetIdClient),
    {ssr: false, loading: () => <VideoPlayerLoader />},
);

export const ClientSideVideoPlayerByAssetId = (props: ClientSideVideoPlayerByAssetIdProps) => (
    <ClientSideRenderWrapper>
        <DynamicClientSideVideoPlayerByAssetId {...props} />
    </ClientSideRenderWrapper>
);
